import {PatrolPage} from './PatrolPage';
import {PatrolDetailPage} from './PatrolDetailPage'
import { AddSpotPage } from './AddSpotPage';
// import { EditSpotPage } from './EditSpotPage';
import { PatrolUser } from './PatrolUser';
import { PatrolUserForm } from './PatrolUserForm';
// import { PatrolUserDetail } from './PatrolUserDetail';
import { UnauthorizedPage } from '../../components/Unauthorize';
import { KelolaPatrol } from './KelolaPatrol';
import {CreateGroup} from './CreateGroup';
import {AssignUsersToGroup} from './AssignUsersToGroup'
import { GroupSpace } from './GroupSpace';
import { PatrolFormTable } from './PatrolFormTable';

export const admin ={
    PatrolFormTable,
    PatrolDetailPage,
    AddSpotPage,
    // EditSpotPage,
    PatrolUser,
    PatrolUserForm,
    // PatrolUserDetail,
    KelolaPatrol,
    UnauthorizedPage,
    CreateGroup,
    AssignUsersToGroup,
    GroupSpace,
};